import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertService } from './alert.service';

@Injectable({
    providedIn: 'root'
})
export class FileDownloadService {
    constructor(private alert: AlertService) {}

    downloadFile(result: HttpResponse<Blob>) {
        try {
            const blob = new Blob([result.body], { type: result.body.type });
            const disposition = result.headers.get('Content-Disposition');
            const splitDisposition: string[] = disposition.split(/filename=/);
            const remove = new RegExp(/[^A-Za-z0-9_.\-\s]/gi);
            const name = splitDisposition[1].replace(remove, '');
            const r = new RegExp(/([A-Za-z0-9_\-\s]+\.[A-Za-z0-9_]+)/);
            let fileName = 'file';
            if (r.test(name)) {
                fileName = r.exec(name)[1];
            }
            //IE 11 not supported in Angular 13
            // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            //   window.navigator.msSaveOrOpenBlob(blob, fileName);
            //   return;
            // }
            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = data;
            link.download = fileName;
            // this is necessary as link.click() does not work on the latest firefox
            link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
                link.remove();
            }, 100);
        } catch (e) {
            this.alert.toastError('We encountered an error downloading the file!');
        }
    }
}
